import React from 'react';
import * as Unicons from '@iconscout/react-unicons';

const data = [
  {
    title: 'Getting started',
    icon: <Unicons.UilPlay size={20} />,
    points: ['What is Zevi.ai?', 'What is Search?', 'What is Chat?', 'Definitions', 'Quick start'],
  },
  {
    title: 'Sending & managing data',
    icon: <Unicons.UilFolderOpen size={20} />,
    points: [
      'Upload products',
      'Select languages',
      'Select columns for indexing',
      'Product catalog API',
    ],
  },
  {
    title: 'Authentication',
    icon: <Unicons.UilShieldCheck size={20} />,
    points: ['Authentication API'],
  },
  {
    title: 'Search',
    icon: <Unicons.UilSearch size={20} />,
    points: ['What is Search?', 'Search API', 'DefinFilters APIitions', 'Configuration'],
  },
  {
    title: 'Chat',
    icon: <Unicons.UilRobot size={20} />,
    points: ['What is chat?', 'Chat API', 'Chat UI integration', 'Definitions', 'Quick start'],
  },
  {
    title: 'Autocomplete',
    icon: <Unicons.UilCheckCircle size={20} />,
    points: ['What is autocomplete?', 'Autocomplete API'],
  },
  {
    title: 'Analytics',
    icon: <Unicons.UilAnalysis size={20} />,
    points: ['What is analytics?', 'Definitions of different metrics', 'Metrics API'],
  },
];

const Card = () => {
  return (
    <div className="Overview">
      {data &&
        data.map((item) => {
          const { title, icon, points } = item;
          return (
            <div className="overViewWrapper" key={title}>
              <div className="cardWrapper">
                <div className="card">{icon}</div>
                <p>{title}</p>
              </div>
              <div className="OverViewText">
                {points &&
                  points.map((point, index) => {
                    return <p>{point}</p>;
                  })}
              </div>
            </div>
          );
        })}
    </div>
  );
};

export default Card;
// What is Zevi.ai? What is Search? What is Chat? Definitions Quick start
